import { provideHttpClient } from "@angular/common/http";
import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { routes } from "./app-routing.module";
import { AppModule } from "./app.module";
import { provideStore } from "@ngrx/store";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { rootReducer } from "./shared/ngrx/root-reducer";
import { provideEffects } from "@ngrx/effects";
import { provideAngularSvgIcon } from "angular-svg-icon";
import { provideState } from "@ngrx/store";
import { environment } from "../environments/environment";

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(AppModule),
    provideRouter(routes),
    provideStore(
      { main: rootReducer },
      {
        // `!isDevMode()` had these dev-only checks running in PRODUCTION only,
        // where each dispatch deep-freezes and re-walks the whole AppState tree.
        // Off everywhere for now: parts of the app still mutate store-held
        // objects in place, so enabling them (in dev, where they belong) is a
        // separate cleanup.
        runtimeChecks: {
          strictStateImmutability: false,
          strictActionImmutability: false,
        },
      }
    ),
    provideState({ name: "main", reducer: rootReducer }),
    provideEffects([]),
    // devtools instrumentation keeps an action/state history in memory for the
    // whole session, so it is switched off in production builds
    // (environment.prod.ts) and on everywhere else, incl. production_debug
    ...(environment.storeDevtoolsSw
      ? [
          provideStoreDevtools({
            maxAge: 25, // Retains last 25 states
            logOnly: !isDevMode(), // Restrict extension to log-only mode
            autoPause: true, // Pauses recording actions and state changes when the extension window is not open
            trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
            traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
            connectInZone: true, // If set to true, the connection is established within the Angular zone
          }),
        ]
      : []),
    provideAnimations(),
    provideHttpClient(),
    provideAngularSvgIcon(),
  ],
};
